export const ArrowRight = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_32357_4821)">
      <path
        d="M5.5 13.4699H16.67L11.79 18.3499C11.4 18.7399 11.4 19.3799 11.79 19.7699C12.18 20.1599 12.81 20.1599 13.2 19.7699L19.79 13.1799C20.18 12.7899 20.18 12.1599 19.79 11.7699L13.21 5.16994C12.82 4.77994 12.19 4.77994 11.8 5.16994C11.41 5.55994 11.41 6.18994 11.8 6.57994L16.67 11.4699H5.5C4.95 11.4699 4.5 11.9199 4.5 12.4699C4.5 13.0199 4.95 13.4699 5.5 13.4699Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_32357_4821">
        <rect
          width="24"
          height="24"
          transform="translate(0.5 0.469971)"
        />
      </clipPath>
    </defs>
  </svg>
);
